// Module
var code = "<massia-form form=\"true\" label=\"{{$ctrl.caracteristique.libelle}}\" label-class=\"{{$ctrl.isObligatoire ? 'mandatory-field' : ''}}\"> <input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.model.value\" ng-disabled=\"$ctrl.lecture\"/> </massia-form> ";
// Exports
module.exports = code;